"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interactionForegroundInit = void 0;
const messages_1 = require("./messages");
const constants_1 = require("./constants");
const handler_1 = require("./handler");
function interactionForegroundInit(router, service) {
    router.registerMessage(messages_1.PushInteractionDataMsg);
    router.registerMessage(messages_1.PushEventDataMsg);
    router.addHandler(constants_1.ROUTE, handler_1.getHandler(service));
}
exports.interactionForegroundInit = interactionForegroundInit;
//# sourceMappingURL=init.js.map